import { Helmet } from 'react-helmet-async';
import React from 'react';
import requireAuth from '../../../lib/requireAuth.jsx';
import withRouterParams from '../../../lib/withRouterParams.jsx';

import ChangeImpactsContainer from '../../../containers/projects/ChangeImpactsContainer.jsx';
import { splitAndMapArrayParam } from '../../utils/index.js';

const ChangeImpactsReviews = ({ projectId, query, slug }) => (
  <>
    <Helmet>
      <title>Change Impact | ChangeSync</title>
    </Helmet>
    <ChangeImpactsContainer projectId={projectId} query={query} slug={slug} />
  </>
);

ChangeImpactsReviews.getInitialProps = ({ query }) => ({
  projectId: Number(query.projectId),
  slug: query.slug,
  query: {
    startDate: query.startDate,
    endDate: query.endDate,
    title: query.title,
    peopleImpacted: query.peopleImpacted,

    actionPlanTypes: splitAndMapArrayParam(query.actionPlanTypes),
    changeImpactTypeIds: splitAndMapArrayParam(
      query.changeImpactTypeIds,
      Number
    ),
    scale: splitAndMapArrayParam(query.scale),
    perceptions: splitAndMapArrayParam(query.perceptions),
    actionPlanStatuses: splitAndMapArrayParam(query.actionPlanStatuses),
    taskStatuses: splitAndMapArrayParam(query.taskStatuses),
    taskOwnerIds: splitAndMapArrayParam(query.taskOwnerIds, Number),

    ownerIds: splitAndMapArrayParam(query.ownerIds, Number),
    impactedEmployeesIds: splitAndMapArrayParam(
      query.impactedEmployeesIds,
      Number
    ),
    impactedGroupsIds: splitAndMapArrayParam(query.impactedGroupsIds, Number),
    impactedExternalEntitiesIds: splitAndMapArrayParam(
      query.impactedExternalEntitiesIds,
      Number
    ),
    organizationStakeholderIds: splitAndMapArrayParam(
      query.organizationStakeholderIds,
      Number
    ),
    taskIds: splitAndMapArrayParam(query.taskIds, Number),
  },
});

export default requireAuth(withRouterParams(ChangeImpactsReviews));
